webpackJsonp([1],Array(48).concat([
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return toggleIndicators; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return openCloseAll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setAria; });
/**
 * Shows and hides indicators for a single subcategory
 * @param {String} viewType
 */
function toggleIndicators(viewType) {
  this.subcategory.showCurrentIndicators = !this.subcategory.showCurrentIndicators;
}
/**
 * shows or hides all indicators.
 *
 * @param {string} viewType used to indicate which screen is being opened if we
 * want the indicators to reset to close on new screens
 * @param {boolian} openBool
 */
function openCloseAll(viewType, openBool) {
  var i = void 0;
  var j = void 0;
  for (i = 0; i < this.categories.length; i += 1) {
    for (j = 0; j < this.categories[i].subcategories.length; j += 1) {
      this.categories[i].subcategories[j][viewType] = openBool;
    }
  }
}
function setAria() {
  this.$el.setAttribute('aria-hidden', !this.showIndicators);
}



/***/ }),
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(455)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(189),
  /* template */
  __webpack_require__(535),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 72 */,
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This function assigns a class to each year column based on the number of
 * quarters in the year. The classes narrow the width of the year column.
 */
/* harmony default export */ __webpack_exports__["a"] = (function () {
  var quarterClasses = ['one-q', 'two-q', 'three-q', 'four-q'];
  return quarterClasses[this.yearData.quarters.length - 1];
});

/***/ }),
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * function sets the hovered flag on inidicators.
 * The flag is used to highlight the hovered row.
 * @param {boolean} isHovered
 */
/* harmony default export */ __webpack_exports__["a"] = (function (isHovered) {
  this.indicator.indicatorHovered = isHovered;
});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This function prevents the page jump
 * links in the montior description from interfearing with therouter
 *
 */
function beforeRouteLeave(to, from, next) {
  var notRoutes = ['macro', 'market', 'credit', 'solvency', 'funding', 'contagion'];
  if (notRoutes.indexOf(to.name) >= 0) {
    this.$router.push(this.$route.path);
  } else if (to.name === 'categories') {
    window.scrollTo(0, 818);
    next();
  } else {
    next();
  }
}

/* harmony default export */ __webpack_exports__["a"] = (beforeRouteLeave);

/***/ }),
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(443)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(188),
  /* template */
  __webpack_require__(523),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(475)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(190),
  /* template */
  __webpack_require__(555),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(480)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(191),
  /* template */
  __webpack_require__(560),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(445)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(192),
  /* template */
  __webpack_require__(525),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(449)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(194),
  /* template */
  __webpack_require__(529),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(457)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(199),
  /* template */
  __webpack_require__(537),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(478)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(213),
  /* template */
  __webpack_require__(558),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_v_tooltip__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_v_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_v_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(185);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_v_tooltip___default.a);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('makeID', function (value) {
  return value.split(' ').join('');
});

/***/ }),
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(109);

/**
 * Module contains a function for creating a state object
 * used for building legends and storing hover and open or closed state.
 */



/**
 * returns an of objects containing the text for the drop downs on
 * the compairson view and the quarter's location in the riskData for
 * look up.
 * @param {object} riskData object containing riskdata for the release.
 */
function buildQuarterList(riskData) {
  var i = void 0;
  var j = void 0;
  var year = void 0;
  var quarter = void 0;
  var count = 0;
  var quarters = [];
  for (i = riskData.length - 1; i > -1; i -= 1) {
    year = riskData[i];
    for (j = year.quarters.length - 1; j > -1; j -= 1) {
      quarter = year.quarters[j];
      quarters.push({
        name: quarter.quarter + ' ' + year.year,
        value: count,
        yearIndex: i,
        quarterIndex: j
      });
      count += 1;
    }
  }
  return quarters;
}

function isQuarterComplete(riskData, quarter) {
  var quarterData = riskData[quarter.yearIndex].quarters[quarter.quarterIndex].categories;
  var count = 0;
  for (var i = 0; i < quarterData.length; i += 1) {
    if (quarterData[i].score) {
      count += 1;
    }
  }
  return count > 0;
}

/**
 * Checks to see if most recent quarter is complete. If not, sets the initial quarters back one.
 * @param {array} riskData
 * @param {array} quarterList
 */
function setInitialQuarters(riskData, quarterList) {
  var currentA = void 0;
  var currentB = void 0;
  if (isQuarterComplete(riskData, quarterList[0])) {
    currentA = quarterList[4];
    currentB = quarterList[0];
  } else {
    currentA = quarterList[5];
    currentB = quarterList[1];
  }
  return { currentA: currentA, currentB: currentB };
}

/* harmony default export */ __webpack_exports__["a"] = (function (riskData) {
  var i = void 0;
  var j = void 0;
  var k = void 0;
  var category = void 0;
  var categoryObj = void 0;
  var subcategory = void 0;
  var subcategoryObj = void 0;
  var indicator = void 0;
  var indicatorObj = void 0;

  var categories = riskData[0].quarters[0].categories;

  // Set initial view of the long-term view time block
  var end = window.innerWidth > 1200 ? 7 : 6;
  var start = riskData.length - end;
  var timeBlock = {
    end: end,
    start: start,
    // upper limit to prevent users from advancing too far.
    maxStart: start
  };

  var catArray = [];

  for (i = 0; i < categories.length; i += 1) {
    category = categories[i];
    categoryObj = {
      name: category.name,
      subcategories: []
    };

    for (j = 0; j < category.subcategories.length; j += 1) {
      subcategory = category.subcategories[j];
      subcategoryObj = {
        name: subcategory.name,
        indicators: []
      };
      this.$set(subcategoryObj, 'showCurrentIndicators', false);
      // this.$set(subcategoryObj, 'showHistoricalIndicators', false);
      // this.$set(subcategoryObj, 'showVintageIndicators', false);
      for (k = 0; k < subcategory.indicators.length; k += 1) {
        indicator = subcategory.indicators[k];
        indicatorObj = {
          name: indicator.name
        };
        this.$set(indicatorObj, 'indicatorHovered', false);
        subcategoryObj.indicators.push(indicatorObj);
      } // end indicators for loop
      categoryObj.subcategories.push(subcategoryObj);
    } // end subcategories for loop
    catArray.push(categoryObj);
  } // end categories for loop
  var state = { categories: catArray, quarters: buildQuarterList(riskData), timeBlock: timeBlock };
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(state, setInitialQuarters(riskData, state.quarters));

  return state;
});

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function setTimePeriod() {
  var end = void 0;
  var clientWidth = this.screenWidth;
  if (clientWidth >= 1300) {
    end = 7;
  } else if (clientWidth >= 1000) {
    end = 6;
  } else if (clientWidth >= 1024) {
    end = 5;
  } else {
    end = 4;
  }
  var start = this.riskData.length - end;
  this.state.timeBlock = {
    start: start,
    end: end,
    maxStart: start
  };
}

/* harmony default export */ __webpack_exports__["a"] = (setTimePeriod);

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_comparison_Comparison__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_comparison_Comparison___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_comparison_Comparison__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_long_term_map_LongTermMap__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_long_term_map_LongTermMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_long_term_map_LongTermMap__);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'compare-quarters',
    component: __WEBPACK_IMPORTED_MODULE_2__components_comparison_Comparison___default.a,
    props: true
  }, {
    path: '/historical-view/',
    name: 'historical-view',
    component: __WEBPACK_IMPORTED_MODULE_3__components_long_term_map_LongTermMap___default.a,
    props: true
  },
  // dummy routes so we can handle the page jumps.
  {
    path: '/macro',
    name: 'macro',
    component: __WEBPACK_IMPORTED_MODULE_2__components_comparison_Comparison___default.a,
    props: true
  }, {
    path: '/market',
    name: 'market',
    component: __WEBPACK_IMPORTED_MODULE_2__components_comparison_Comparison___default.a,
    props: true
  }, {
    path: '/credit',
    name: 'credit',
    component: __WEBPACK_IMPORTED_MODULE_2__components_comparison_Comparison___default.a,
    props: true
  }, {
    path: '/solvency',
    name: 'solvency',
    component: __WEBPACK_IMPORTED_MODULE_2__components_comparison_Comparison___default.a,
    props: true
  }, {
    path: '/funding',
    name: 'funding',
    component: __WEBPACK_IMPORTED_MODULE_2__components_comparison_Comparison___default.a,
    props: true
  }, {
    path: '/contagion',
    name: 'contagion',
    component: __WEBPACK_IMPORTED_MODULE_2__components_comparison_Comparison___default.a,
    props: true
  }, {
    path: '/categories',
    name: 'categories',
    component: __WEBPACK_IMPORTED_MODULE_2__components_comparison_Comparison___default.a,
    props: true
  },
  // default to compare quarters
  {
    path: '*',
    redirect: '/'
  }]
}));

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  text: ['Contains measures of macroeconomic risks to the financial system such as inflation, excessive government borrowing, and excessive reliance on cross-border financing.', 'Contains measures of market risk such as excessive valuations, low risk premiums, and excesses in financial risk appetite and risk-taking. ', 'Contains measures of credit risk in the real economy &mdash; the risk of widespread credit defaults or delinquencies by households and nonfinancial businesses.', 'Contains measures of excessive leverage at financial institutions or other risks to their solvency.', 'Contains measures of risks in short-term funding arrangements and liquidity for financial markets and financial institutions.', 'Contains measures of potential vulnerabilities from stress transmission across financial institutions and markets, within concentrated financial sectors, and from other countries to the U.S. financial system.']
});

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_storeHelpers__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_nav_AppNav__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_nav_AppNav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_app_nav_AppNav__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_windowResize__ = __webpack_require__(184);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var URL = "/financial-vulnerabilities/data/RiskData.json";

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    'app-nav': __WEBPACK_IMPORTED_MODULE_2__components_app_nav_AppNav___default.a
  },
  data: function data() {
    return {
      riskData: null,
      state: {},
      errors: [],
      grayscale: false,
      loading: true,
      screenWidth: window.innerWidth
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(URL).then(function (response) {
      _this.riskData = response.data;
      _this.state = _this.createState(response.data);
      _this.setLoading();
      _this.setTimePeriod();
    }).catch(function (e) {
      _this.errors.push(e);
    });
  },
  mounted: function mounted() {
    window.addEventListener('resize', this.setWindowWidth.bind(this));
  },

  methods: {
    createState: __WEBPACK_IMPORTED_MODULE_1__helpers_storeHelpers__["a" /* default */],
    setTimePeriod: __WEBPACK_IMPORTED_MODULE_3__helpers_windowResize__["a" /* default */],
    toggleScale: function toggleScale() {
      this.grayscale = !this.grayscale;
    },
    setLoading: function setLoading(loadBool) {
      this.loading = loadBool;
    },
    setWindowWidth: function setWindowWidth() {
      this.screenWidth = window.innerWidth;
    }
  },
  computed: {
    currentView: function currentView() {
      return this.$route.name;
    },
    timeBlock: function timeBlock() {
      var start = this.state.timeBlock.start;
      var end = start + this.state.timeBlock.end;
      return this.riskData.slice(start, end);
    },
    smallScreen: function smallScreen() {
      return this.screenWidth < 700;
    }
  },
  watch: {
    screenWidth: function screenWidth() {
      this.setTimePeriod();
    }
  }
});

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'download-button',
  data: function data() {
    return {
      downloadLink: "/financial-vulnerabilities/files/fsvm_scores.xlsx",
      downloadIconClass: "prod-download-icon"
    };
  }
});

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'color-block',
  props: ['score', 'name', 'ishovered'],
  data: function data() {
    return {
      classList: ['none', 'one', 'two', 'three', 'four', 'five', 'six']
    };
  },

  computed: {
    colorClass: function colorClass() {
      var color = this.score === null ? 'none' : this.classList[this.score];
      return color;
    },
    classes: function classes() {
      if (this.ishovered) {
        return this.colorClass + ' active';
      }
      return this.colorClass;
    }
  }
});

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_openCloseHelpers__ = __webpack_require__(48);
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'open-hide-all-controls',
  props: ['categories'],
  data: function data() {
    return {
      viewProperties: {
        'long-term-map': 'ShowHistoricalIndicators',
        'comparison-view': 'showCurrentIndicators'
      }
    };
  },

  methods: {
    openCloseAll: __WEBPACK_IMPORTED_MODULE_0__helpers_openCloseHelpers__["b" /* openCloseAll */]
  },
  computed: {
    viewProperty: function viewProperty() {
      return this.viewProperties[this.$route.name];
    }
  }
});

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'scale-toggle',
  props: ['grayscale', 'toggleScale'],
  computed: {
    checked: function checked() {
      return this.grayscale;
    }
  }
});

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toolTipsText__ = __webpack_require__(186);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'tool-tip',
  props: ['index'],
  data: function data() {
    return {
      tooltip: __WEBPACK_IMPORTED_MODULE_0__toolTipsText__["a" /* default */].text[this.index]
    };
  }
});

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app-nav',
  props: ['smallScreen']
});

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'color-legend',
  props: ['orientation']
});

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CategoryScoreColumn__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CategoryScoreColumn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__CategoryScoreColumn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SubcategoryScores__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SubcategoryScores___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__SubcategoryScores__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'category-row',
  props: ['category', 'catIndex', 'columnAScores', 'columnBScores'],
  components: {
    'cat-score-column': __WEBPACK_IMPORTED_MODULE_0__CategoryScoreColumn___default.a,
    'subcat-score-column': __WEBPACK_IMPORTED_MODULE_1__SubcategoryScores___default.a
  }
});

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MapColorBlock__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MapColorBlock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__MapColorBlock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ToolTip__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ToolTip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ToolTip__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'category-scores',
  props: ['categoryName', 'columnAScore', 'columnBScore', 'catIndex'],
  components: {
    'color-block': __WEBPACK_IMPORTED_MODULE_0__MapColorBlock___default.a,
    'tool-tip': __WEBPACK_IMPORTED_MODULE_1__ToolTip___default.a
  }
});

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ControlsColumn__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ControlsColumn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ControlsColumn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GraphicColumn__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GraphicColumn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__GraphicColumn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_navHelpers__ = __webpack_require__(116);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'comparison',
  props: ['riskData', 'state', 'grayscale', 'toggleScale', 'setLoading'],
  components: {
    'controls-column': __WEBPACK_IMPORTED_MODULE_0__ControlsColumn___default.a,
    'graphic-column': __WEBPACK_IMPORTED_MODULE_1__GraphicColumn___default.a
  },
  methods: {
    updateQuarter: function updateQuarter(aOrb, quarterIndex) {
      var newQuarter = this.state.quarters[quarterIndex];
      if (aOrb === 'A') this.state.currentA = newQuarter;
      if (aOrb === 'B') this.state.currentB = newQuarter;
    }
  },
  computed: {
    currentA: function currentA() {
      return this.state.currentA;
    },
    currentB: function currentB() {
      return this.state.currentB;
    }
  },
  beforeRouteLeave: __WEBPACK_IMPORTED_MODULE_2__helpers_navHelpers__["a" /* default */],
  beforeMount: function beforeMount() {
    if (this.$route.name === 'categories') {
      window.scrollTo(0, 818);
    }
  }
});

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CurrentControls__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CurrentControls___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__CurrentControls__);
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'controls-column',
  props: ['grayscale', 'toggleScale'],
  components: {
    'current-controls': __WEBPACK_IMPORTED_MODULE_0__CurrentControls___default.a
  }
});

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__color_legend_ColorLegend__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__color_legend_ColorLegend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__color_legend_ColorLegend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ScaleToggle__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ScaleToggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ScaleToggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Download__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Download___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Download__);
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'current-controls',
  props: ['grayscale', 'toggleScale'],
  components: {
    'color-legend': __WEBPACK_IMPORTED_MODULE_0__color_legend_ColorLegend___default.a,
    'scale-toggle': __WEBPACK_IMPORTED_MODULE_1__ScaleToggle___default.a,
    'download-button': __WEBPACK_IMPORTED_MODULE_2__Download___default.a
  }
});

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__IndicatorScoreBlock__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__IndicatorScoreBlock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__IndicatorScoreBlock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_openCloseHelpers__ = __webpack_require__(48);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'subcat-row',
  props: ['subcategory', 'subcatColumnA', 'subcatColumnB'],
  components: {
    'indicator-block': __WEBPACK_IMPORTED_MODULE_0__IndicatorScoreBlock___default.a
  },
  computed: {
    showIndicators: function showIndicators() {
      return this.subcategory.showCurrentIndicators;
    },
    iconClass: function iconClass() {
      return this.showIndicators ? 'fa-caret-down' : 'fa-caret-right';
    }
  },
  methods: {
    toggleIndicators: __WEBPACK_IMPORTED_MODULE_1__helpers_openCloseHelpers__["a" /* toggleIndicators */]
  }
});

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CategoryRow__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CategoryRow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__CategoryRow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__QuarterSelect__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__QuarterSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__QuarterSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OpenCloseAll__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OpenCloseAll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__OpenCloseAll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CurrentControls__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CurrentControls___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__CurrentControls__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'graphic-column',
  props: ['quarters', 'riskData', 'categories', 'currentA', 'currentB', 'changeHandler', 'toggleScale', 'grayscale'],
  components: {
    'category-row': __WEBPACK_IMPORTED_MODULE_0__CategoryRow___default.a,
    'quarter-select': __WEBPACK_IMPORTED_MODULE_1__QuarterSelect___default.a,
    'open-close-all': __WEBPACK_IMPORTED_MODULE_2__OpenCloseAll___default.a,
    'current-controls': __WEBPACK_IMPORTED_MODULE_3__CurrentControls___default.a
  },
  methods: {
    getScoreObject: function getScoreObject(quarterObj) {
      var year = quarterObj.yearIndex;
      var quarter = quarterObj.quarterIndex;
      return this.riskData[year].quarters[quarter];
    }
  },
  computed: {
    columnA: function columnA() {
      return this.getScoreObject(this.currentA);
    },
    columnB: function columnB() {
      return this.getScoreObject(this.currentB);
    }
  }
});

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MapColorBlock__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MapColorBlock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__MapColorBlock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_openCloseHelpers__ = __webpack_require__(48);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'indicator-score-block',
  props: ['indicators', 'indicatorsColumnA', 'indicatorsColumnB', 'showIndicators'],
  components: {
    'color-block': __WEBPACK_IMPORTED_MODULE_0__MapColorBlock___default.a
  },
  watch: {
    showIndicators: __WEBPACK_IMPORTED_MODULE_1__helpers_openCloseHelpers__["c" /* setAria */]
  }
});

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'quaterSelect',
  props: ['aorb', 'quarters', 'current', 'changeHandler'],
  data: function data() {
    return {
      currentSelection: '',
      labelText: '',
      selectId: ''
    };
  },
  created: function created() {
    this.currentSelection = this.current.value;
    this.labelText = 'Quarter ' + this.aorb;
    this.selectId = 'select' + this.aorb;
  },

  watch: {
    currentSelection: function currentSelection() {
      this.changeHandler(this.aorb, this.currentSelection);
    }
  }
});

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CurrentSubcatRow__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CurrentSubcatRow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__CurrentSubcatRow__);
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'subcategory-scores',
  props: ['subcategories', 'columnAsubcats', 'columnBsubcats'],
  components: {
    'subcat-row': __WEBPACK_IMPORTED_MODULE_0__CurrentSubcatRow___default.a
  }
});

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__heat_map_legend_HeatMapLegend__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__heat_map_legend_HeatMapLegend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__heat_map_legend_HeatMapLegend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__heat_map_graphic_HeatMapGraphic__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__heat_map_graphic_HeatMapGraphic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__heat_map_graphic_HeatMapGraphic__);
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'heat-map-container',
  props: ['timeBlock', 'state'],
  components: {
    'map-legend': __WEBPACK_IMPORTED_MODULE_0__heat_map_legend_HeatMapLegend___default.a,
    'map-graphic': __WEBPACK_IMPORTED_MODULE_1__heat_map_graphic_HeatMapGraphic___default.a
  }
});

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CategoryScoresYearColumn__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CategoryScoresYearColumn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__CategoryScoresYearColumn__);
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'category-scores-year-column',
  props: ['catIndex', 'riskData'],
  components: {
    'year-column': __WEBPACK_IMPORTED_MODULE_0__CategoryScoresYearColumn___default.a
  }
});

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MapColorBlock__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MapColorBlock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__MapColorBlock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_numQuarters__ = __webpack_require__(73);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cat-scores-year-column',
  props: ['catIndex', 'yearData'],
  components: {
    'color-block': __WEBPACK_IMPORTED_MODULE_0__MapColorBlock___default.a
  },
  computed: {
    numQuarters: __WEBPACK_IMPORTED_MODULE_1__helpers_numQuarters__["a" /* default */]
  }
});

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__YearColumn__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__YearColumn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__YearColumn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MapCategoryRow__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MapCategoryRow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MapCategoryRow__);
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'heatmap',
  props: ['timeBlock', 'state'],
  components: {
    'year-column': __WEBPACK_IMPORTED_MODULE_0__YearColumn___default.a,
    'category-row': __WEBPACK_IMPORTED_MODULE_1__MapCategoryRow___default.a
  }
});

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CategoryScoresRow__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CategoryScoresRow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__CategoryScoresRow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MapSubcatRow__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MapSubcatRow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MapSubcatRow__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'map-category-row',
  props: ['category', 'riskData', 'catIndex'],
  components: {
    'category-scores': __WEBPACK_IMPORTED_MODULE_0__CategoryScoresRow___default.a,
    'subcategory-row': __WEBPACK_IMPORTED_MODULE_1__MapSubcatRow___default.a
  }
});

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MapColorBlock__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MapColorBlock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__MapColorBlock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_hoverHelpers__ = __webpack_require__(115);
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'map-indicator',
  props: ['indicator', 'indicatorScore'],
  components: {
    'color-block': __WEBPACK_IMPORTED_MODULE_0__MapColorBlock___default.a
  },
  methods: {
    handleHover: __WEBPACK_IMPORTED_MODULE_1__helpers_hoverHelpers__["a" /* default */]
  }
});

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__YearColumn__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__YearColumn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__YearColumn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_openCloseHelpers__ = __webpack_require__(48);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'map-subcat-row',
  props: ['subcategory', 'catIndex', 'subcatIndex', 'riskData'],
  components: {
    'year-column': __WEBPACK_IMPORTED_MODULE_0__YearColumn___default.a
  },
  methods: {
    toggleIndicators: __WEBPACK_IMPORTED_MODULE_1__helpers_openCloseHelpers__["a" /* toggleIndicators */]
  }
});

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MapIndicator__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MapIndicator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__MapIndicator__);
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'quarter-column',
  props: ['quarterData', 'subcategory', 'catIndex', 'subcatIndex'],
  components: {
    'map-indicator': __WEBPACK_IMPORTED_MODULE_0__MapIndicator___default.a
  },
  computed: {
    indicatorScores: function indicatorScores() {
      return this.quarterData.categories[this.catIndex].subcategories[this.subcatIndex].indicators;
    }
  }
});

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__QuarterColumn__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__QuarterColumn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__QuarterColumn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_numQuarters__ = __webpack_require__(73);
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'year-column',
  props: ['yearData', 'catIndex', 'subcatIndex', 'subcategory'],
  components: {
    'quarter-column': __WEBPACK_IMPORTED_MODULE_0__QuarterColumn___default.a
  },
  computed: {
    numQuarters: __WEBPACK_IMPORTED_MODULE_1__helpers_numQuarters__["a" /* default */]
  }
});

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LegendCatBlock__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LegendCatBlock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__LegendCatBlock__);
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'heat-map-legend',
  props: ['state'],
  components: {
    'cat-block': __WEBPACK_IMPORTED_MODULE_0__LegendCatBlock___default.a
  }
});

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LegendSubcatBlock__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LegendSubcatBlock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__LegendSubcatBlock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ToolTip__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ToolTip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ToolTip__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'catblock',
  props: ['category', 'catIndex'],
  components: {
    'subcat-block': __WEBPACK_IMPORTED_MODULE_0__LegendSubcatBlock___default.a,
    'tool-tip': __WEBPACK_IMPORTED_MODULE_1__ToolTip___default.a
  }
});

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_hoverHelpers__ = __webpack_require__(115);
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'legend-indicator',
  props: ['indicator'],
  methods: {
    handleHover: __WEBPACK_IMPORTED_MODULE_0__helpers_hoverHelpers__["a" /* default */]
  }
});

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LegendIndicator__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LegendIndicator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__LegendIndicator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_openCloseHelpers__ = __webpack_require__(48);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'legend-subcat-block',
  props: ['subcategory'],
  components: {
    'legend-indicator': __WEBPACK_IMPORTED_MODULE_0__LegendIndicator___default.a
  },
  computed: {
    collapseIcon: function collapseIcon() {
      return this.subcategory.showCurrentIndicators ? 'fa fa-caret-down' : 'fa fa-caret-right';
    }
  },
  methods: {
    toggleIndicators: __WEBPACK_IMPORTED_MODULE_1__helpers_openCloseHelpers__["a" /* toggleIndicators */]
  }
});

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__map_controls_MapControls__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__map_controls_MapControls___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__map_controls_MapControls__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__heat_map_container_HeatMapContainer__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__heat_map_container_HeatMapContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__heat_map_container_HeatMapContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_navHelpers__ = __webpack_require__(116);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'long-term-map',
  props: ['riskData', 'state', 'grayscale', 'toggleScale', 'timeBlock', 'setLoading', 'smallScreen'],
  components: {
    'map-controls': __WEBPACK_IMPORTED_MODULE_0__map_controls_MapControls___default.a,
    'map-container': __WEBPACK_IMPORTED_MODULE_1__heat_map_container_HeatMapContainer___default.a
  },
  data: function data() {
    return {
      downloadLink: "/financial-vulnerabilities/files/fsvm_scores.xlsx"
    };
  },
  mounted: function mounted() {
    this.setLoading(false);
  },

  beforeRouteLeave: __WEBPACK_IMPORTED_MODULE_2__helpers_navHelpers__["a" /* default */]
});

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MapControlsRight__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MapControlsRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__MapControlsRight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MapControlsLeft__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MapControlsLeft___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MapControlsLeft__);
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'map-controls',
  props: ['grayscale', 'toggleScale', 'state', 'riskData'],
  components: {
    'map-controls-left': __WEBPACK_IMPORTED_MODULE_1__MapControlsLeft___default.a,
    'map-controls-right': __WEBPACK_IMPORTED_MODULE_0__MapControlsRight___default.a
  }
});

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MapControlsDatesColumn__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MapControlsDatesColumn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__MapControlsDatesColumn__);
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'map-control-dates',
  props: ['riskData'],
  components: {
    'map-year-label-column': __WEBPACK_IMPORTED_MODULE_0__MapControlsDatesColumn___default.a
  }
});

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_numQuarters__ = __webpack_require__(73);
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'map-controls-dates-column',
  props: ['yearData'],
  computed: {
    numQuarters: __WEBPACK_IMPORTED_MODULE_0__helpers_numQuarters__["a" /* default */]
  }
});

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__OpenCloseAll__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__OpenCloseAll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__OpenCloseAll__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'map-contorls-left',
  props: ['categories'],
  components: {
    'open-close-all': __WEBPACK_IMPORTED_MODULE_0__OpenCloseAll___default.a
  }
});

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__color_legend_ColorLegend__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__color_legend_ColorLegend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__color_legend_ColorLegend__);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'map-legend',
  components: {
    'color-legend': __WEBPACK_IMPORTED_MODULE_0__color_legend_ColorLegend___default.a
  }
});

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MapControlsLegend__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MapControlsLegend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__MapControlsLegend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MapControlsYearNavigation__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MapControlsYearNavigation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MapControlsYearNavigation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MapControlsDates__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MapControlsDates___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MapControlsDates__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ScaleToggle__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ScaleToggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ScaleToggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Download__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Download___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Download__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'map-contorls-right',
  props: ['grayscale', 'toggleScale', 'state', 'riskData'],
  components: {
    'map-controls-legend': __WEBPACK_IMPORTED_MODULE_0__MapControlsLegend___default.a,
    'map-year-nav': __WEBPACK_IMPORTED_MODULE_1__MapControlsYearNavigation___default.a,
    'map-controls-dates': __WEBPACK_IMPORTED_MODULE_2__MapControlsDates___default.a,
    'scale-toggle': __WEBPACK_IMPORTED_MODULE_3__ScaleToggle___default.a,
    'download-button': __WEBPACK_IMPORTED_MODULE_4__Download___default.a
  }
});

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MapControlsYearNavigationSet__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MapControlsYearNavigationSet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__MapControlsYearNavigationSet__);
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'map-controls-year-nav',
  props: ['state'],
  components: {
    'year-nav-set': __WEBPACK_IMPORTED_MODULE_0__MapControlsYearNavigationSet___default.a
  }
});

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'year-nav-button',
  props: ['state', 'direction', 'increment'],
  computed: {
    buttonText: function buttonText() {
      var faIconClass = this.direction > 0 ? 'fa-caret-right' : 'fa-caret-left';
      var icon = '<i class="fa ' + faIconClass + '"></i>';
      if (this.increment === 'end' || this.increment === 'begining') {
        var srText = '<span class="sr-only">go to ' + this.increment + '</span>';
        return '' + icon + icon + srText;
      }
      return this.direction > 0 ? '<span class="increment-text">' + this.increment + '</span> ' + icon : icon + ' <span class="increment-text">' + this.increment + '</span>';
    },
    textAlign: function textAlign() {
      return this.direction > 0 ? 'text-right' : 'text-left';
    },
    isDisabled: function isDisabled() {
      var isAscending = this.direction > 0;
      var currentStart = this.state.timeBlock.start;
      var maxStart = this.state.timeBlock.maxStart;

      if (isAscending && currentStart === maxStart || !isAscending && currentStart === 0) {
        return true;
      }
      return false;
    }
  },
  methods: {
    navigateYears: function navigateYears() {
      if (this.increment === 'begining') {
        this.state.timeBlock.start = 0;
      } else if (this.increment === 'end') {
        this.state.timeBlock.start = this.state.timeBlock.maxStart;
      } else {
        var movement = this.direction * this.increment;
        var newStart = this.state.timeBlock.start + movement;
        if (newStart > this.state.timeBlock.maxStart) {
          this.state.timeBlock.start = this.state.timeBlock.maxStart;
        } else if (newStart < 0) {
          this.state.timeBlock.start = 0;
        } else {
          this.state.timeBlock.start = newStart;
        }
      }
    }
  }
});

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MapControlsYearNavigationButton__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MapControlsYearNavigationButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MapControlsYearNavigationButton__);

//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'year-nav-set',
  // direction is either 1 or -1
  props: ['state', 'direction'],
  components: {
    'year-nav-button': __WEBPACK_IMPORTED_MODULE_1__MapControlsYearNavigationButton___default.a
  },
  data: function data() {
    return {
      increments: [1, 5]
    };
  },

  computed: {
    sortedIncrements: function sortedIncrements() {
      var isDescending = this.direction < 0;
      var increments = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.increments));
      var lastIncrement = isDescending ? 'begining' : 'end';
      increments.push(lastIncrement);
      return isDescending ? increments.reverse() : increments;
    }
  }
});

/***/ }),
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 442 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 443 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 444 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 445 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 446 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 447 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 448 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 449 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 450 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 451 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 452 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 453 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 454 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 455 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 456 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 457 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 458 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 459 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 460 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 461 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 462 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 463 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 464 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 465 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 466 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 467 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 468 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 469 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 470 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 471 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 472 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 473 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 474 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 475 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 476 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 477 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 478 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 479 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 480 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 481 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(474)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(187),
  /* template */
  __webpack_require__(554),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(470)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(193),
  /* template */
  __webpack_require__(550),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(452)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(195),
  /* template */
  __webpack_require__(532),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(477)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(196),
  /* template */
  __webpack_require__(557),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(448)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(197),
  /* template */
  __webpack_require__(528),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(450)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(198),
  /* template */
  __webpack_require__(530),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(473)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(200),
  /* template */
  __webpack_require__(553),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(462)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(201),
  /* template */
  __webpack_require__(542),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(444)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(202),
  /* template */
  __webpack_require__(524),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(466)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(203),
  /* template */
  __webpack_require__(546),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(456)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(204),
  /* template */
  __webpack_require__(536),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(446)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(205),
  /* template */
  __webpack_require__(526),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(468)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(206),
  /* template */
  __webpack_require__(548),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(471)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(207),
  /* template */
  __webpack_require__(551),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(441)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(208),
  /* template */
  __webpack_require__(521),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(463)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(209),
  /* template */
  __webpack_require__(543),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(481)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(210),
  /* template */
  __webpack_require__(561),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(476)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(211),
  /* template */
  __webpack_require__(556),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(454)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(212),
  /* template */
  __webpack_require__(534),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(469)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(214),
  /* template */
  __webpack_require__(549),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6f91e753",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(459)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(215),
  /* template */
  __webpack_require__(539),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(458)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(216),
  /* template */
  __webpack_require__(538),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(453)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(217),
  /* template */
  __webpack_require__(533),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(465)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(218),
  /* template */
  __webpack_require__(545),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(451)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(219),
  /* template */
  __webpack_require__(531),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(460)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(220),
  /* template */
  __webpack_require__(540),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(467)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(221),
  /* template */
  __webpack_require__(547),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(461)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(222),
  /* template */
  __webpack_require__(541),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(472)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(223),
  /* template */
  __webpack_require__(552),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(442)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(224),
  /* template */
  __webpack_require__(522),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(447)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(225),
  /* template */
  __webpack_require__(527),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(464)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(226),
  /* template */
  __webpack_require__(544),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(479)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(227),
  /* template */
  __webpack_require__(559),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 521 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "heatmap-container right-column"
  }, [_c('div', {
    staticClass: "heatmap-inner"
  }, _vm._l((_vm.state.categories), function(category, index) {
    return _c('category-row', {
      key: _vm._f("makeID")(category.name),
      attrs: {
        "category": category,
        "riskData": _vm.timeBlock,
        "catIndex": index
      }
    })
  }))])
},staticRenderFns: []}

/***/ }),
/* 522 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "map-controls-right-wrapper right-column"
  }, [_c('div', {
    staticClass: "map-controls-right-top-row"
  }, [_c('map-controls-legend'), _vm._v(" "), _c('scale-toggle', {
    attrs: {
      "grayscale": _vm.grayscale,
      "toggleScale": _vm.toggleScale
    }
  }), _vm._v(" "), _c('download-button')], 1), _vm._v(" "), _c('map-year-nav', {
    attrs: {
      "state": _vm.state
    }
  }), _vm._v(" "), _c('map-controls-dates', {
    attrs: {
      "riskData": _vm.riskData
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 523 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "download-form",
    attrs: {
      "method": "get",
      "action": _vm.downloadLink
    }
  }, [_c('button', {
    staticClass: "fvhm-download",
    class: _vm.downloadIconClass,
    attrs: {
      "type": "submit",
      "data-placement": "bottom",
      "title": "Download monitor data"
    }
  }, [_vm._v("Data")])])
},staticRenderFns: []}

/***/ }),
/* 524 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "indicators-scores-block",
    attrs: {
      "aria-hidden": "true"
    }
  }, _vm._l((_vm.indicators), function(indicator, index) {
    return _c('div', {
      key: indicator.name,
      staticClass: "current-indicator-row"
    }, [_c('div', {
      staticClass: "indicator-score"
    }, [_c('color-block', {
      attrs: {
        "score": _vm.indicatorsColumnA[index].score,
        "isHovered": false,
        "name": ("column B " + (indicator.name))
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "indicator-score"
    }, [_c('color-block', {
      attrs: {
        "score": _vm.indicatorsColumnB[index].score,
        "isHovered": false,
        "name": ("column B " + (indicator.name))
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "current-indicator-name"
    }, [_vm._v(_vm._s(indicator.name))])])
  }))
},staticRenderFns: []}

/***/ }),
/* 525 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.right-start",
      value: (_vm.tooltip),
      expression: "tooltip",
      modifiers: {
        "right-start": true
      }
    }],
    staticClass: "cat-tooltip-wrapper",
    attrs: {
      "role": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle"
  })])
},staticRenderFns: []}

/***/ }),
/* 526 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "heat-map-container"
  }, [_c('map-legend', {
    attrs: {
      "state": _vm.state
    }
  }), _vm._v(" "), _c('map-graphic', {
    attrs: {
      "timeBlock": _vm.timeBlock,
      "state": _vm.state
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 527 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "map-controls-year-nav-wrapper"
  }, [_c('year-nav-set', {
    attrs: {
      "state": _vm.state,
      "direction": -1
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "year-nav-label text-center"
  }, [_vm._v("Navigate Years")]), _vm._v(" "), _c('year-nav-set', {
    attrs: {
      "state": _vm.state,
      "direction": 1
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 528 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "current-wrapper"
  }, [_c('graphic-column', {
    attrs: {
      "quarters": _vm.state.quarters,
      "changeHandler": _vm.updateQuarter,
      "riskData": _vm.riskData,
      "currentA": _vm.currentA,
      "currentB": _vm.currentB,
      "categories": _vm.state.categories,
      "toggleScale": _vm.toggleScale,
      "grayscale": _vm.grayscale
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 529 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "color-legend-wrapper"
  }, [_c('p', {
    staticClass: "color-legend-title"
  }, [_vm._v("Potential Vulnerability")]), _vm._v(" "), _c('div', {
    staticClass: "color-legend",
    class: _vm.orientation
  }, [_c('div', {
    staticClass: "color-label left-label"
  }, [_vm._v("Low")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "color-label right-label"
  }, [_vm._v("High")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "color-row"
  }, [_c('div', {
    staticClass: "legend-color-block one"
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("1")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "color-row"
  }, [_c('div', {
    staticClass: "legend-color-block two"
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("2")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "color-row"
  }, [_c('div', {
    staticClass: "legend-color-block three"
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("3")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "color-row"
  }, [_c('div', {
    staticClass: "legend-color-block four"
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("4")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "color-row"
  }, [_c('div', {
    staticClass: "legend-color-block five"
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("5")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "color-row"
  }, [_c('div', {
    staticClass: "legend-color-block six"
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("6")])])])
}]}

/***/ }),
/* 530 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "controls-column-wrapper"
  }, [_c('current-controls', {
    attrs: {
      "grayscale": _vm.grayscale,
      "toggleScale": _vm.toggleScale
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 531 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "map-controls-wrapper"
  }, [_c('map-controls-left', {
    attrs: {
      "categories": _vm.state.categories
    }
  }), _vm._v(" "), _c('map-controls-right', {
    attrs: {
      "grayscale": _vm.grayscale,
      "toggleScale": _vm.toggleScale,
      "state": _vm.state,
      "riskData": _vm.riskData
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 532 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "category-row"
  }, [_c('cat-score-column', {
    attrs: {
      "categoryName": _vm.category.name,
      "columnAScore": _vm.columnAScores.score,
      "columnBScore": _vm.columnBScores.score,
      "catIndex": _vm.catIndex
    }
  }), _vm._v(" "), _c('subcat-score-column', {
    attrs: {
      "subcategories": _vm.category.subcategories,
      "columnAsubcats": _vm.columnAScores.subcategories,
      "columnBsubcats": _vm.columnBScores.subcategories
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 533 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "subcat-label-block"
  }, [_c('div', {
    staticClass: "subcat-label",
    attrs: {
      "tabindex": "0"
    },
    on: {
      "click": _vm.toggleIndicators,
      "keyup": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.toggleIndicators($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "space", 32)) { return null; }
        _vm.toggleIndicators($event)
      }]
    }
  }, [_c('i', {
    staticClass: "fa collapse-icon",
    class: _vm.collapseIcon,
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.subcategory.name) + "\n")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "collapse"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.subcategory.showCurrentIndicators),
      expression: "subcategory.showCurrentIndicators"
    }],
    staticClass: "indicators-block",
    attrs: {
      "aria-hidden": !_vm.subcategory.showCurrentIndicators
    }
  }, _vm._l((_vm.subcategory.indicators), function(indicator) {
    return _c('legend-indicator', {
      key: _vm._f("makeID")(indicator.name),
      attrs: {
        "indicator": indicator
      }
    }, [_vm._v("\n          " + _vm._s(indicator.name) + "\n      ")])
  }))])], 1)
},staticRenderFns: []}

/***/ }),
/* 534 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "quarter-column"
  }, _vm._l((_vm.subcategory.indicators), function(indicator, index) {
    return _c('map-indicator', {
      key: _vm._f("makeID")(indicator.name),
      attrs: {
        "indicator": indicator,
        "indicatorScore": _vm.indicatorScores[index].score
      }
    })
  }))
},staticRenderFns: []}

/***/ }),
/* 535 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "color-block",
    class: _vm.classes
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v(_vm._s(_vm.score))])])
},staticRenderFns: []}

/***/ }),
/* 536 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "subcat-score-column-wrapper"
  }, _vm._l((_vm.subcategories), function(subcategory, index) {
    return _c('subcat-row', {
      key: subcategory.name,
      attrs: {
        "subcategory": subcategory,
        "subcatColumnA": _vm.columnAsubcats[index],
        "subcatColumnB": _vm.columnBsubcats[index]
      }
    })
  }))
},staticRenderFns: []}

/***/ }),
/* 537 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "current-controls-wrapper"
  }, [_c('color-legend', {
    staticClass: "compare-scale",
    attrs: {
      "orientation": 'horizontal'
    }
  }), _vm._v(" "), _c('scale-toggle', {
    staticClass: "compare-toggle",
    attrs: {
      "grayscale": _vm.grayscale,
      "toggleScale": _vm.toggleScale
    }
  }), _vm._v(" "), _c('download-button')], 1)
},staticRenderFns: []}

/***/ }),
/* 538 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "indicator-label",
    class: {
      hovered: _vm.indicator.indicatorHovered
    },
    on: {
      "mouseenter": function($event) {
        _vm.handleHover(true)
      },
      "mouseleave": function($event) {
        _vm.handleHover(false)
      }
    }
  }, [_vm._v("\n  " + _vm._s(_vm.indicator.name) + "\n  ")])
},staticRenderFns: []}

/***/ }),
/* 539 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cat-block cat-block-margin"
  }, [_c('div', {
    staticClass: "cat-title"
  }, [_vm._v("\n    " + _vm._s(_vm.category.name) + " "), _c('tool-tip', {
    attrs: {
      "index": _vm.catIndex
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "subcat-col"
  }, _vm._l((_vm.category.subcategories), function(subcategory) {
    return _c('subcat-block', {
      key: subcategory.name,
      attrs: {
        "subcategory": subcategory
      }
    })
  }))])
},staticRenderFns: []}

/***/ }),
/* 540 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cat-year-row cursor-scroll-all"
  }, [_c('transition', {
    attrs: {
      "name": "cat-year-row"
    }
  }, [_c('div', {
    staticClass: "cat-year-row-inner"
  }, _vm._l((_vm.riskData), function(year) {
    return _c('map-year-label-column', {
      key: year.year,
      attrs: {
        "yearData": year
      }
    })
  }))])], 1)
},staticRenderFns: []}

/***/ }),
/* 541 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "map-controls-left-wrapper left-column"
  }, [_c('div', {
    staticClass: "map-show-controls-Wrapper"
  }, [_c('open-close-all', {
    attrs: {
      "categories": _vm.categories
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 542 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "graphic-wrapper"
  }, [_c('div', {
    staticClass: "select-row-wrapper"
  }, [_c('div', {
    staticClass: "select-row"
  }, [_c('quarter-select', {
    attrs: {
      "aorb": 'A',
      "quarters": _vm.quarters,
      "current": _vm.currentA,
      "changeHandler": _vm.changeHandler
    }
  }), _vm._v(" "), _c('quarter-select', {
    attrs: {
      "aorb": 'B',
      "quarters": _vm.quarters,
      "current": _vm.currentB,
      "changeHandler": _vm.changeHandler
    }
  })], 1), _vm._v(" "), _c('open-close-all', {
    attrs: {
      "categories": _vm.categories
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "compare-controls-right"
  }, [_c('current-controls', {
    attrs: {
      "grayscale": _vm.grayscale,
      "toggleScale": _vm.toggleScale
    }
  })], 1)], 1), _vm._v(" "), _vm._l((_vm.categories), function(category, index) {
    return _c('category-row', {
      key: category.score,
      attrs: {
        "category": category,
        "columnAScores": _vm.columnA.categories[index],
        "columnBScores": _vm.columnB.categories[index],
        "catIndex": index
      }
    })
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 543 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "map-cat-row cat-block-margin"
  }, [_c('category-scores', {
    attrs: {
      "catIndex": _vm.catIndex,
      "riskData": _vm.riskData
    }
  }), _vm._v(" "), _vm._l((_vm.category.subcategories), function(subcategory, index) {
    return _c('subcategory-row', {
      key: _vm._f("makeID")(subcategory.name),
      attrs: {
        "catIndex": _vm.catIndex,
        "subcatIndex": index,
        "riskData": _vm.riskData,
        "subcategory": _vm.category.subcategories[index]
      }
    })
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 544 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "map-year-nav-btn",
    class: _vm.textAlign
  }, [(_vm.isDisabled) ? _c('span', {
    staticClass: "year-nav-disabled",
    domProps: {
      "innerHTML": _vm._s(_vm.buttonText)
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isDisabled) ? _c('a', {
    attrs: {
      "tabindex": "0",
      "role": "button"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.buttonText)
    },
    on: {
      "click": _vm.navigateYears,
      "keyup": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.navigateYears($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "space", 32)) { return null; }
        _vm.navigateYears($event)
      }]
    }
  }) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 545 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "long-term-wrapper"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.smallScreen),
      expression: "smallScreen"
    }]
  }, [_vm._v("Your device is too narrow to display this graphic. Please visit this page from a larger device or "), _c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("go to the Compare Quarters view")]), _vm._v(".")], 1), _vm._v(" "), _c('map-controls', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.smallScreen),
      expression: "!smallScreen"
    }],
    attrs: {
      "grayscale": _vm.grayscale,
      "toggleScale": _vm.toggleScale,
      "state": _vm.state,
      "riskData": _vm.timeBlock
    }
  }), _vm._v(" "), _c('map-container', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.smallScreen),
      expression: "!smallScreen"
    }],
    attrs: {
      "timeBlock": _vm.timeBlock,
      "state": _vm.state
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 546 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "select-wrapper"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentSelection),
      expression: "currentSelection"
    }],
    staticClass: "form-control",
    attrs: {
      "id": _vm.selectId,
      "aria-label": _vm.labelText
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.currentSelection = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.quarters), function(quarter) {
    return _c('option', {
      key: quarter.value,
      domProps: {
        "value": quarter.value
      }
    }, [_vm._v("\n        " + _vm._s(quarter.name) + "\n      ")])
  }))])
},staticRenderFns: []}

/***/ }),
/* 547 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cat-year-label-wrapper",
    class: _vm.numQuarters
  }, [_c('div', {
    staticClass: "cat-year-label"
  }, [_vm._v(_vm._s(_vm.yearData.year))]), _vm._v(" "), _c('div', {
    staticClass: "quarters-label-wrapper"
  }, _vm._l((_vm.yearData.quarters), function(quarter) {
    return _c('div', {
      key: ((_vm.yearData.year) + "_" + (quarter.quarter)),
      staticClass: "quarter-label"
    }, [_vm._v("\n        " + _vm._s(quarter.quarter) + "\n    ")])
  }))])
},staticRenderFns: []}

/***/ }),
/* 548 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "category-scores-wrapper"
  }, _vm._l((_vm.riskData), function(year) {
    return _c('year-column', {
      key: year.year,
      attrs: {
        "yearData": year,
        "catIndex": _vm.catIndex
      }
    })
  }))
},staticRenderFns: []}

/***/ }),
/* 549 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hist-legend left-column"
  }, _vm._l((_vm.state.categories), function(category, index) {
    return _c('cat-block', {
      key: category.name,
      attrs: {
        "category": category,
        "catIndex": index
      }
    })
  }))
},staticRenderFns: []}

/***/ }),
/* 550 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-nav"
  }, [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.smallScreen),
      expression: "!smallScreen"
    }],
    staticClass: "app-nav-list"
  }, [_c('router-link', {
    attrs: {
      "to": "/",
      "tag": "li"
    }
  }, [_c('a', {
    staticClass: "app-router-link",
    attrs: {
      "tabindex": "0"
    }
  }, [_vm._v("Compare Quarters")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/historical-view",
      "tag": "li"
    }
  }, [_c('a', {
    staticClass: "app-router-link",
    attrs: {
      "tabindex": "0"
    }
  }, [_vm._v("Historical View")])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 551 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cat-scores-year-wrapper year-column",
    class: _vm.numQuarters
  }, _vm._l((_vm.yearData.quarters), function(quarter) {
    return _c('div', {
      key: quarter.quarter,
      staticClass: "quarter-column"
    }, [_c('div', {
      staticClass: "map-score-block category-block"
    }, [_c('color-block', {
      attrs: {
        "score": quarter.categories[_vm.catIndex].score,
        "name": quarter.categories[_vm.catIndex].name,
        "ishovered": false
      }
    })], 1)])
  }))
},staticRenderFns: []}

/***/ }),
/* 552 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "map-legend-wrapper"
  }, [_c('color-legend', {
    attrs: {
      "orientation": 'horizontal'
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 553 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "subcat-row"
  }, [_c('div', {
    staticClass: "subcat-row-label",
    attrs: {
      "tabindex": "0",
      "role": "button"
    },
    on: {
      "click": _vm.toggleIndicators,
      "keyup": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.toggleIndicators($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "space", 32)) { return null; }
        _vm.toggleIndicators($event)
      }]
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa",
    class: _vm.iconClass
  })]), _vm._v(" "), _c('span', {
    staticClass: "current-subcat-title"
  }, [_vm._v(_vm._s(_vm.subcategory.name))])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "collapse"
    }
  }, [_c('indicator-block', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showIndicators),
      expression: "showIndicators"
    }],
    attrs: {
      "indicators": _vm.subcategory.indicators,
      "indicatorsColumnA": _vm.subcatColumnA.indicators,
      "indicatorsColumnB": _vm.subcatColumnB.indicators,
      "showIndicators": _vm.showIndicators
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 554 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'grayscale': _vm.grayscale
    },
    attrs: {
      "id": "app"
    }
  }, [_c('app-nav', {
    attrs: {
      "smallScreen": _vm.smallScreen
    }
  }), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.riskData) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }]
  }, [_c('transition', {
    attrs: {
      "name": "route"
    }
  }, [_c('router-view', {
    attrs: {
      "state": _vm.state,
      "riskData": _vm.riskData,
      "timeBlock": _vm.timeBlock,
      "grayscale": _vm.grayscale,
      "toggleScale": _vm.toggleScale,
      "setLoading": _vm.setLoading,
      "smallScreen": _vm.smallScreen
    }
  })], 1)], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Loading...")])
}]}

/***/ }),
/* 555 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "expand-all-controls-wrapper"
  }, [_c('label', {
    staticClass: "expand-label"
  }, [_vm._v("\n    Indicators\n  ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary first",
    on: {
      "click": function($event) {
        _vm.openCloseAll('showCurrentIndicators', true)
      }
    }
  }, [_vm._v("Show All")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.openCloseAll('showCurrentIndicators', false)
      }
    }
  }, [_vm._v("Hide All")])])
},staticRenderFns: []}

/***/ }),
/* 556 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "map-subcat-row"
  }, [_c('div', {
    staticClass: "subcat-spacer",
    on: {
      "click": _vm.toggleIndicators
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "collapse"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.subcategory.showCurrentIndicators),
      expression: "subcategory.showCurrentIndicators"
    }],
    staticClass: "indicator-wrapper cursor-scroll-all",
    attrs: {
      "aria-hidden": !_vm.subcategory.showCurrentIndicators
    }
  }, _vm._l((_vm.riskData), function(yearData) {
    return _c('year-column', {
      key: yearData.year,
      attrs: {
        "yearData": yearData,
        "catIndex": _vm.catIndex,
        "subcatIndex": _vm.subcatIndex,
        "subcategory": _vm.subcategory
      }
    })
  }))])], 1)
},staticRenderFns: []}

/***/ }),
/* 557 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cat-score-column-wrapper"
  }, [_c('div', {
    staticClass: "cat-score-title"
  }, [_vm._v(_vm._s(_vm.categoryName) + " "), _c('tool-tip', {
    attrs: {
      "index": _vm.catIndex
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "cat-scores-wrapper"
  }, [_c('div', {
    staticClass: "score-block"
  }, [_c('color-block', {
    attrs: {
      "score": _vm.columnAScore,
      "ishovered": false,
      "name": _vm.categoryName
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "score-block"
  }, [_c('color-block', {
    attrs: {
      "score": _vm.columnBScore,
      "ishovered": false,
      "name": _vm.categoryName
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 558 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "year-column",
    class: _vm.numQuarters
  }, _vm._l((_vm.yearData.quarters), function(quarter) {
    return _c('quarter-column', {
      key: quarter.quarter,
      attrs: {
        "subcategory": _vm.subcategory,
        "catIndex": _vm.catIndex,
        "subcatIndex": _vm.subcatIndex,
        "quarterData": quarter
      }
    })
  }))
},staticRenderFns: []}

/***/ }),
/* 559 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "map-year-nav-set-wrapper"
  }, _vm._l((_vm.sortedIncrements), function(increment) {
    return _c('year-nav-button', {
      key: increment,
      attrs: {
        "state": _vm.state,
        "direction": _vm.direction,
        "increment": increment
      }
    })
  }))
},staticRenderFns: []}

/***/ }),
/* 560 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkbox colorscale-checkbox"
  }, [_c('label', [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.checked
    },
    on: {
      "change": _vm.toggleScale
    }
  }), _vm._v("Grayscale\n  ")])])
},staticRenderFns: []}

/***/ }),
/* 561 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "map-score-block map-indicator-block",
    on: {
      "mouseenter": function($event) {
        _vm.handleHover(true)
      },
      "mouseleave": function($event) {
        _vm.handleHover(false)
      }
    }
  }, [_c('color-block', {
    attrs: {
      "score": _vm.indicatorScore,
      "name": _vm.indicator.name,
      "ishovered": _vm.indicator.indicatorHovered
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 562 */,
/* 563 */,
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(164);
module.exports = __webpack_require__(163);


/***/ })
]),[564]);


// WEBPACK FOOTER //
// static/js/app.7432be48cb7ea1d0b225.js